export const styles = {
  textBoldUnderline: {
    fontSize: 14,
    fontWeight: "400",
    color: "#136598",
  },
  hText: { fontSize: 15, fontWeight: "400" },
  hHeader: { fontSize: 15, fontWeight: "bold", flex: 4 },
  tableHeader: { fontSize: 14, fontWeight: "bold" },
  tableProps: { borderColor: "black", borderLeftWidth: 0, borderRightWidth: 0 },
  hTextBold: { fontSize: 15, fontWeight: "bold" },
  hTextCritical: { fontSize: 15, fontWeight: "bold", color: "#C44904" },
  hTextMajor: { fontSize: 15, fontWeight: "bold", color: "orange" },
  hTextMinor: { fontSize: 15, fontWeight: "bold", color: "#A7A7A7" },
  hTextWarning: { fontSize: 15, fontWeight: "bold", color: "purple" },
  hTextRead: { fontSize: 15, fontWeight: "bold", color: "#A7A7A7" },
  hTextClosed: { fontSize: 15, fontWeight: "bold", color: "#00AC3E" },
};

export const getStyle = (text) => {
  switch (text.toLowerCase()) {
    case "critical":
      return styles.hTextCritical;
      break;
    case "major":
      return styles.hTextMajor;
      break;
    case "warning":
      return styles.hTextWarning;
      break;
    case "minor":
      return styles.hTextMinor;
      break;
    default:
      return styles.hTextBold;
      break;
  }
};
